import { AspectRatio, Box, Text } from '@chakra-ui/react'
import { LivePosterFragment } from 'web-queries/src/types/generated'
import React from 'react'
import Image from 'next/image'

import { findImage, getMediaPath } from '../utils/image'
import useTranslation from 'next-translate/useTranslation'
import { isVideo } from '../utils/poster'

interface Props {
  defaultImageUrl?: string
  livePoster: LivePosterFragment
  useImageLazyLoad?: boolean
}

export default function LivePoster({
  defaultImageUrl = '/images/bg_music_live_stage.jpg',
  livePoster,
  useImageLazyLoad = false,
}: Props) {
  const { t } = useTranslation('live')
  const livePosterImage = findImage(livePoster.posters[0]?.formats)?.url
  const imageUrl = livePosterImage ? getMediaPath(livePosterImage) : defaultImageUrl

  const alt = t('altText', {
    title: livePoster.title,
  })

  const isVideoPoster = livePoster.posters.length > 0 && isVideo(livePoster.posters[0])

  return (
    <Box position="relative">
      <AspectRatio ratio={3 / 4} bgColor="#000">
        <>
          {isVideoPoster && (
            <Box>
              <video src={getMediaPath(livePoster.posters[0].url)} muted autoPlay loop playsInline />
            </Box>
          )}
          {!isVideoPoster && (
            <Image src={imageUrl} objectFit="contain" layout="fill" alt={alt} priority={!useImageLazyLoad} />
          )}
        </>
      </AspectRatio>
      {livePoster.isCanceled && (
        <>
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            zIndex="3"
            backgroundColor="rgba(255, 255, 255, 0.7)"
          />
          <Box
            position="absolute"
            left="50%"
            top="50%"
            transform="translate(-50%, -50%)"
            backgroundColor="gray.600"
            padding={['16px', '24px']}
            borderRadius="16px"
            zIndex="4"
            fontSize={['sm', 'md', 'xl']}
          >
            <Text>CANCELED</Text>
          </Box>
        </>
      )}
    </Box>
  )
}
